import { Users } from 'lucide-react'

export default function Agents() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Agents</h1>
        <p className="mt-1 text-sm text-gray-500">
          View and manage individual agents across all swarms
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center">
        <Users className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Agent Management</h3>
        <p className="text-gray-500 max-w-md mx-auto">
          View detailed information about individual agents, their performance metrics, 
          and execution history. Navigate to a specific swarm to see its agents.
        </p>
      </div>
    </div>
  )
}
